import "@/App.css";
import ChatPage from "@/components/ChatPage";

function App() {
  return (
    <div className="App">
      <ChatPage />
    </div>
  );
}

export default App;
